<template>
  <div class="app">
    <div id="snackbar-imply" class="snackbar-imply"></div>
    <div id="snackbar-imply-sucesso" class="snackbar-imply-sucesso"></div>
    <div id="loading-imply" class="loading" style="display: none">
      <img src="@/assets/img/loading.gif" alt />
    </div>
    <router-view />

  </div>
</template>
<script>

export default {
  data: () => ({}),
  methods: {
    navigateTo(route) {
      this.$router.push({ name: route });
    },
    snackbarImply(msn) {
      let div = document.getElementById("snackbar-imply");
      div.innerHTML = msn;
      div.style.display = "block";
      setTimeout(function () {
        div.style.display = "none";
      }, 3000);
    },
    snackbarImplySucesso(msn) {
      let div = document.getElementById("snackbar-imply-sucesso");
      div.innerHTML = msn;
      div.style.display = "block";
      setTimeout(function () {
        div.style.display = "none";
      }, 3000);
    },
  },
};
</script>
<style>
.app {
  height: 100vh;
  box-sizing: border-box;
}

* {
  box-sizing: border-box;
}

.loading {
  position: fixed;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fdfdfd;
  z-index: 2147483647;
}

.snackbar-imply {
  position: fixed;
  width: calc(100% - 40px);
  padding: 10px;
  margin: 10px;
  background: #ff9e9e;
  border-radius: 5px;
  border: solid 1px rgba(204, 0, 0, 1);
  color: rgba(204, 0, 0, 1);
  display: none;
  z-index: 99999;
  text-align: center;
}

.snackbar-imply-sucesso {
  position: fixed;
  width: calc(100% - 40px);
  padding: 10px;
  margin: 10px;
  background: #20c95e;
  border-radius: 5px;
  border: solid 1px #20c95e;
  color: #ffffff;
  display: none;
  z-index: 99999;
  text-align: center;
}

/** checar se está em standalone no android */
@media all and (display-mode: standalone) {
}

@media (display-mode: fullscreen) {
}

/** VARIAVEIS DO APLICATIVO */
:root {
  --primary: #000000;
  /** Cinza Claro */
  --secondary: #7ab648;
  /** Verde */
  --accent: #a4a4a4;
  /** Icones */
  --error: rgb(255, 35, 35);
  --background: #f3f3f3;
  --navbar: #e7e7e7;
  --gray: #808080;
  --white: #ffffff;
  --success: #108f30;
}

/** ======================== */
h1,
h2,
h3,
h4,
h5,
h6 {
  /* color: #00356c; */
  text-transform: uppercase;
}

html,
body {
  scroll-behavior: smooth;
  height: 100% !important;
  background: var(--white);
}

fieldset {
  background-color: var(--white);
  border: 1px solid #e2e2e2 !important;
}

label[required]:after {
  content: " *";
  color: var(--secondary);
  position: relative;
  bottom: 8px;
}

.v-messages__message {
  line-height: 14px !important;
}

.toast-text {
  font-family: "Helvética";
  font-weight: 500;
}

.label {
  font-weight: 500 !important;
  color: var(--gray);
  font-size: 18px !important;
}

.toast-text {
  font-family: "Helvética";
  font-weight: 500;
}

.label {
  font-weight: 500 !important;
  color: var(--gray);
  font-size: 18px !important;
}

.install-card {
  position: fixed !important;
  z-index: 99999;
  bottom: 10px;
  width: 100%;
  box-shadow: 0px 0px 2px 1px whitesmoke !important;
  font-size: 10px;
  margin: 0 auto !important;
  text-align: center;
}

.install-button {
  margin: 5px;
}

.icon-close-install {
  float: right !important;
}

.notification-modal {
  position: fixed !important;
  z-index: 99999;
  margin: 20px;
}

.container-install-samsung {
  width: min-content;
  z-index: 9999999;
  position: fixed;
  right: 5%;
  text-align: center;
}

@keyframes arrow-jump {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
    -webkit-transform: translateY(-10px);
    -moz-transform: translateY(-10px);
    -o-transform: translateY(-10px);
    transform: translateY(-10px);
  }
}

.icon-instalar-samsung {
  -webkit-animation: arrow-jump 1s infinite;
  -moz-animation: arrow-jump 1s infinite;
  -o-animation: arrow-jump 1s infinite;
  animation: arrow-jump 1s infinite;
}

.icon-imply,
.mdi {
  width: 24px;
  height: 24px;
  align-items: center;
  display: inline-flex;
  font-feature-settings: "liga";
  font-size: 24px;
  justify-content: center;
  letter-spacing: normal;
  line-height: 1;
  position: relative;
  text-indent: 0;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  mask-size: cover;
  -webkit-mask-size: cover;
  -moz-mask-size: cover;
  -ms-mask-size: cover;
}

.v-application .yellow--text.text--darken-3 {
  background: #f9a825 !important;
  width: 40px;
  height: 40px;
  mask-size: cover;
  -webkit-mask-size: cover;
  -moz-mask-size: cover;
  -ms-mask-size: cover;
}

.v-application .grey--text.text--darken-1 {
  background: #757575 !important;
  width: 40px;
  height: 40px;
  mask-size: cover;
  -webkit-mask-size: cover;
  -moz-mask-size: cover;
  -ms-mask-size: cover;
}

.orientation-alert {
  display: none;
}

.container-geral {
  width: 100%;
  height: 100%;
}

.ipy-container {
  max-width: 1025px;
  height: 100%;
  margin: 0 auto;
}

input,
select {
  height: 45px !important;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  padding: 0px 15px;
}

button {
  height: 45px;
  border-radius: 5px !important;
  padding: 0px 15px;
  justify-content: center;
  display: flex;
  align-items: center;
}

@media screen and (max-width: 1024px) {
  .ipy-container {
    max-width: 100%;
    width: calc(100% - 30px);
  }
}

.icon-white {
  background: white;
}

.icon-gray {
  background: rgb(110, 110, 110);
}

.icon-black {
  background: black;
}

.icon-green {
  background: #68c920;
}

.icon-red {
  background: #d80027;
}

.icon-blue {
  background: #1f4b95;
}

.icon-blue-info {
  background: #1867c0;
}

.icon-orange {
  background: #ff8310;
}

.icon-success-color {
  background: #28a745;
}

.icon-error-color {
  background: #ff6b6b;
}

.icon-fechar {
  position: absolute;
  right: 0px;
  margin: 10px;
  top: 0px;
  cursor: pointer;
}

.icon-click {
  cursor: pointer;
}

.close-circle {
  mask: url("./assets/icons/close-circle.svg");
}

.icon-save {
  mask: url("./assets/icons/icon-save.svg");
}

.info-icon-cred {
  mask: url("./assets/icons/info.svg");
}

.menu {
  mask: url("./assets/icons/menu.svg");
}

.gmail {
  mask: url("./assets/icons/gmail.svg");
}

.printer {
  mask: url("./assets/icons/printer.svg");
}

.search {
  mask: url("./assets/icons/magnify.svg");
}

.calendar {
  mask: url("./assets/icons/calendar-month.svg");
}

.calendar-plus {
  mask: url("./assets/icons/calendar-plus.svg");
}

.edit {
  mask: url("./assets/icons/pencil.svg");
}

.remove {
  mask: url("./assets/icons/delete.svg");
}

.trocar {
  mask: url("./assets/icons/cached.svg");
}

.menu-down {
  mask: url("./assets/icons/menu-down.svg");
}

.whatsapp {
  mask: url("./assets/icons/whatsapp.svg");
}

.translate {
  mask: url("./assets/icons/translate.svg");
}

.person {
  mask: url("./assets/icons/vector.svg");
}

.person-group {
  mask: url("./assets/icons/group-line.svg");
}

.visitor {
  mask: url("./assets/icons/user-shared-line.svg");
}

.access-info {
  mask: url("./assets/icons/file-chart-line.svg");
}

.access-code {
  mask: url("./assets/icons/access-code.svg");
}

.logout {
  mask: url("./assets/icons/logout.svg");
}

.chevron-right {
  mask: url("./assets/icons/arrow-right.svg");
}

.vehicle {
  mask: url("./assets/icons/vehicle.svg");
}

.events {
  mask: url("./assets/icons/events.svg");
}

.lock {
  mask: url("./assets/icons/lock.svg");
}

.key {
  mask: url("./assets/icons/key-solid.svg");
}

.check {
  mask: url("./assets/icons/checkbox-check.svg");
}

.block {
  mask: url("./assets/icons/checkbox-block.svg");
}

.plus-circle {
  mask: url("./assets/icons/plus-circle.svg");
}

.delete-trash {
  mask: url("./assets/icons/delete-trash.svg");
}

.cloud-upload {
  mask: url("./assets/icons/cloud-upload.svg");
}

.information {
  mask: url("./assets/icons/information-circle-outline.svg");
}

.eye-open {
  mask: url("./assets/icons/eye-open.svg");
}

.eye-close {
  mask: url("./assets/icons/eye-close.svg");
}

.arrow-left-back {
  mask: url("./assets/icons/arrow-left.svg");
}

.arrow-up {
  mask: url("./assets/icons/arrow-up.svg");
}

.arrow-down {
  mask: url("./assets/icons/arrow-down.svg");
}

.search {
  mask: url("./assets/icons/search.svg");
}

.icon-status-onboard {
  mask: url("./assets/icons/image-circle-line.svg");
}

.send-email {
  mask: url("./assets/icons/send-email.svg");
}

.info {
  mask: url("./assets/icons/info.svg");
}

.student {
  mask: url("./assets/icons/student.svg");
}

.edit-box-pencil {
  mask: url("./assets/icons/edit-pencil.svg");
}

.company-icon {
  mask: url("./assets/icons/company.svg");
}

.icon-check {
  mask: url("./assets/icons/check.svg");
}

.icon-close {
  mask: url("./assets/icons/close.svg");
}

.icon-times-solid-close {
  mask: url("./assets/icons/times-solid-close.svg");
}

.door {
  mask: url("./assets/icons/door-open.svg");
}

.qrcode {
  mask: url("./assets/icons/qrcode.svg");
}

.qrcode-onboarding {
  mask: url("./assets/icons/qrcode-onboarding.svg");
}

.account-icon {
  mask: url("./assets/icons/account-outline.svg");
}

.notification-icon {
  mask: url("./assets/icons/bell-check-outline.svg");
}
.camera-icon {
  mask: url("./assets/cam/ic_photo_camera_white_48px.svg");
}

.error-icon {
  mask: url("./assets/icons/circle-xmark-regular.svg");
}

.success-icon {
  mask: url("./assets/icons/circle-check-regular.svg");
}

.photo-icon {
  mask: url("./assets/icons/photo-icon.svg");
}

.dots-vertical {
  mask: url("./assets/icons/ellipsis-vertical-solid.svg");
}

.send-email-forward {
  mask: url("./assets/icons/send-email-forward.svg");
}

/* CSS TOOTIP */
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
</style>
